import { render, staticRenderFns } from "./complete-beauty-profile.vue?vue&type=template&id=131bf73f&"
import script from "./complete-beauty-profile.vue?vue&type=script&lang=js&"
export * from "./complete-beauty-profile.vue?vue&type=script&lang=js&"
import style0 from "./complete-beauty-profile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports